<section *ngIf="loaded" class="left-nav-wrapper bg-grey scroll-container">
  <div *ngIf="manualChecks?.length >= 1" class="offset-2 col-8 bg-white rounded mt-5 p-4">
    <h4><strong>Manual Checks</strong></h4>
    <p class="pt-3 pb-2">
      The following checks were issued outside of payroll. Checks marked
      <em class="cp-green"><strong>Accept</strong></em>
      will be included in this payroll run to record wages and taxes for W2 reporting. Unselect
      check(s) that you do not want to include. They will be permanently deleted when this payroll
      is submitted.
    </p>

    <table class="table">
      <thead>
        <tr class="fw-bold">
          <th class="text-center">Accept</th>
          <th>Check #</th>
          <th>Name</th>
          <th>Total</th>
          <th>Date Created</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let manualCheck of manualChecks">
          <td class="text-center">
            <input
              class="small"
              type="checkbox"
              id="{{ manualCheck.Id }}"
              (change)="onManualCheckChange($event)"
              checked="checked" />
            <label for="{{ manualCheck.Id }}"><span></span> </label>
          </td>
          <td>
            <input
              class="form-control mb-0"
              [(ngModel)]="manualCheck.CheckNumber"
              (ngModelChange)="updateCheckNumber(manualCheck.Id)"
              maxlength="10"
              alphaNumeric
              data-testid="manual-check-number" />
          </td>
          <td>{{ manualCheck.Name }}</td>
          <td>{{ manualCheck.Total | currency }}</td>
          <td>{{ manualCheck.DateCreated | date: 'MM/dd/yyyy' }}</td>
        </tr>
      </tbody>
    </table>

    <div class="text-end mt-3">
      <button
        class="btn btn-primary"
        cpGTagEvent
        [params]="{ event_label: 'manual_check_checks_included' }"
        (click)="goToTimeclock()">
        Continue
      </button>
    </div>
  </div>
</section>
